fragment BookingTicketDetails on BookingNode {
  tickets {
    id
    seatGroup {
      id
      name
    }
    concessionType {
      id
      name
    }
    checkedInAt
    checkedInBy {
      firstName
      lastName
    }
  }
}
